const optionsList = [
    { value: 'no-longer', label: 'I no longer want to receive these emails' },
    { value: 'too-frequent', label: 'Emails are too frequent' },
    { value: 'never-signed-up', label: 'I never signed up for this mailing list' },
    { value: 'not-relevant', label: 'The emails aren’t relevant to me. I already have a solution' },
    { value: 'spam', label: 'The emails are misleading or spam' },
    { value: 'other', label: 'Other (please specify)' },
];
export default optionsList;
